import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/styles/main.scss'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

var $ = require( "jquery" );

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.mixin({
  data(){
    return{
      globalVariables: {indexCount : 0}
    }
  },
  methods: {
    throttle(){
      var now = Date.now();
      if (now > this.$data.lastCall + this.$data.interval) {
          this.$data.lastCall = now;
          this.throttleFunc();
        }
    },
    activateFadeables(){
      var windowBottom = $(window).scrollTop() + $(window).innerHeight();
      $(".fadeable").each(function () {
          /* Check the location of each desired element */
          var objectBottom = $(this).offset().top + $(this).outerHeight() / 10;
          /* If the element is completely within bounds of the window, fade it in */
          if (objectBottom < windowBottom) {
              //object comes into view (scrolling down)
              if ($(this).css("opacity") == 0) {
                  $(this).fadeTo(900, 1);
                  $(this).css("transform", "none");
                  $(this).css("transition", "transform 0.9s ease-out");
              }
          } else {
              //object goes out of view (scrolling up)
              if ($(this).css("opacity") == 1) {
                  $(this).fadeTo(0, 0);
                  $(this).css("transform", "translateY(10vh)");
              }
          }
      });
    }
  },
})

const firebaseConfig = {
  apiKey: "AIzaSyBd16GVuvcztsyvnD5O3E1lf4QBwn96H-8",
  authDomain: "belasia-labs.firebaseapp.com",
  projectId: "belasia-labs",
  storageBucket: "belasia-labs.appspot.com",
  messagingSenderId: "298524424460",
  appId: "1:298524424460:web:e0341c92fdd6ee5d1b3129",
  measurementId: "G-RLC33H33Y8"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

new Vue({
  BootstrapVue,
  app,
  analytics,
  router,
  render: h => h(App)
}).$mount('#app')
